@if (status.invalid ) {
  <div class="input-component"
    >
    <div class="error">{{ status.error | translate}}</div>
  </div>
} @else {
  <div>&nbsp;</div>
}
